.kdx-site-search {

  display: flex;
  justify-content: flex-start;
  align-items: center;
  width: 394px;
  margin-right: 24px;

  .container {
    display: flex;
    justify-content: flex-start;
    align-items: center;

    span {
      display: none;
    }

    select.search-categories {
      font-family: $font-family-primary;
      width: auto;
      @include text-size(16);
      @include line-height(24);
      font-weight: 500;
      color: $primary;
      padding: 8px 30px 8px 16px;
      border: 1px solid #AAAAAA;
      border-right: none;
      background-color: #FFFFFF;
      border-radius: 5px 0 0 5px;
      height: 40px;
      appearance: none;
      -webkit-appearance: none;
      -moz-appearance: none;
      background-image: url("data:image/svg+xml,%3Csvg xmlns='http://www.w3.org/2000/svg' height='1em' viewBox='0 0 448 512'%3E%3Cpath d='M207.029 381.476L12.686 187.132c-9.373-9.373-9.373-24.569 0-33.941l22.667-22.667c9.357-9.357 24.522-9.375 33.901-.04L224 284.505l154.745-154.021c9.379-9.335 24.544-9.317 33.901.04l22.667 22.667c9.373 9.373 9.373 24.569 0 33.941L240.971 381.476c-9.373 9.372-24.569 9.372-33.942 0z' fill='%230669AA' /%3E%3C/svg%3E");
      background-repeat: no-repeat;
      cursor: pointer;

      option {
        font-family: $font-family-primary;
      }
    }

    .input-container {
      width: 290px;
      position: relative;

      input {
        width: 100%;
        padding: 11px 16px;
        border: 1px solid #AAAAAA;
        background-color: #F4F4F4;
        border-radius: 0 5px 5px 0;
        @include text-size(16);
        height: 40px;

        @include placeholder {
          font-style: normal;
          @include text-size(16);
          @include line-height(24);
          font-family: $font-family-primary;
        }

        &.no-categories{
          background-color: #FFFFFF;
          border-radius: 5px;
        }
      }

      button[type='submit'].input-group-text {
        position: absolute;
        padding: 0;
        top: 50%;
        right: 16px;
        /* Adjust the positioning as needed */
        transform: translateY(-50%);
        background: none;
        border: none;

        svg {
          @include svg-format(17px, 17px, $primary);
          overflow: visible;
          margin-bottom: 8px;
        }
      }
    }
  }

  &.simple-searchbox {

    .container {
      justify-content: flex-end;
    }
  }
}


@include media-breakpoint-down(xl) {

  .kdx-site-search:not(.simple-searchbox) {

    display: none;
    height: calc(100% - 90px);
    position: fixed;
    width: 100%;
    padding-top: 32px;
    overflow-y: scroll;
    top: 0;
    left: 0;
    z-index: 999;
    background-color: #F4F4F4;
    flex-direction: column;
    justify-content: flex-start;
    align-items: center;

    &.show {
      display: flex;
    }

    .container {
      flex-direction: column;

      span {
        display: block;
        color: #10244F;
        @include text-size(22);
        @include line-height(28);
        font-family: $font-family-primary;
        font-weight: 500;
        margin-bottom: 24px;
        text-align: center;
      }

      select.search-categories {
        width: 100%;
        padding: 10px 16px;
        border-right: 1px solid #AAAAAA;
        border-radius: 5px;
        margin-bottom: 24px;
      }

      .input-container {
        width: 100%;
        position: relative;

        input {
          width: 100%;
          background-color: #FFFFFF;
          border-radius: 5px;
        }

        button[type='submit'].input-group-text {
          position: absolute;
          padding: 0;
          top: 50%;
          right: 16px;
          /* Adjust the positioning as needed */
          transform: translateY(-50%);
          background: none;
          border: none;

          svg {
            @include svg-format(17px, 17px, $primary);
            overflow: visible;
            margin-bottom: 8px;
          }
        }
      }
    }
  }

  .kdx-site-search.simple-searchbox {

    width: 100%;

    .container {

      .input-container {
        width: 100%;
      }
    }
  }
}